import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useEffect, useState } from 'react';
import useMountedState from 'react-use/lib/useMountedState';
import { generateTableDataUrls } from '../devTools/devToolsTableGraphicsPage';
import { ALL_THEME_BACKGROUND_PROPERTIES, ALL_THEME_BACKGROUND_TYPES } from '../types/themeBackgroundTypes';
import { GameGuidePowerPlayerFeatureIndicator } from './gameGuidePowerPlayerFeatureIndicator';
const TABLE_WIDTH = 150;
const TABLE_HEIGHT = 100;
const OPTIONS_CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  filter: drop-shadow(6px 6px 0 rgba(0, 0, 0, 0.15));
`;
const BACKGROUND_CONTAINER_CSS = css `
  border: 4px solid black;
  width: 100px;
  height: 100px;
  overflow: hidden;
  margin: 5px;
`;
const TABLE_CONTAINER_CSS = css `
  padding: 5px;
`;
export const CustomizableThemesGameGuideContents = () => {
    const isMounted = useMountedState();
    const [tableDataUrls, setTableDataUrls] = useState([]);
    useEffect(() => {
        async function effect() {
            let dataUrls = [];
            try {
                dataUrls = await generateTableDataUrls(TABLE_WIDTH * 2, TABLE_HEIGHT * 2);
            }
            catch {
                // could not get canvas rendering context
                dataUrls = [];
            }
            if (!isMounted()) {
                return;
            }
            setTableDataUrls(dataUrls);
        }
        effect();
    }, [isMounted]);
    return (_jsxs(_Fragment, { children: [_jsx(GameGuidePowerPlayerFeatureIndicator, {}), _jsx("p", {}), "To customize the game's appearance, you can set the table color and background for poker rooms. From a poker room, open either your Self Panel or Settings to find theme options.", _jsx("p", {}), _jsx("h3", { children: "Room Backgrounds" }), _jsx("div", { css: OPTIONS_CONTAINER_CSS, children: ALL_THEME_BACKGROUND_TYPES.map((themeBackgroundType, i) => (_jsx("div", { css: BACKGROUND_CONTAINER_CSS, children: _jsx("img", { src: ALL_THEME_BACKGROUND_PROPERTIES[themeBackgroundType].imageUrl }) }, i))) }), _jsx("p", {}), tableDataUrls.length > 0 && (_jsxs(_Fragment, { children: [_jsx("h3", { children: "Table Colors" }), _jsx("div", { css: OPTIONS_CONTAINER_CSS, children: tableDataUrls.map((tableDataUrl, i) => (_jsx("div", { css: TABLE_CONTAINER_CSS, children: _jsx("img", { src: tableDataUrl, width: TABLE_WIDTH, height: TABLE_HEIGHT }) }, i))) })] }))] }));
};
